"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemActivityRefPath = exports.SystemActivityStatus = void 0;
var SystemActivityStatus;
(function (SystemActivityStatus) {
    SystemActivityStatus["USER"] = "USER";
    SystemActivityStatus["SYSTEM"] = "SYSTEM";
})(SystemActivityStatus = exports.SystemActivityStatus || (exports.SystemActivityStatus = {}));
var SystemActivityRefPath;
(function (SystemActivityRefPath) {
    SystemActivityRefPath["User"] = "User";
    SystemActivityRefPath["CapturedSearch"] = "CapturedSearch";
    SystemActivityRefPath["SavedSearch"] = "SavedSearch";
})(SystemActivityRefPath = exports.SystemActivityRefPath || (exports.SystemActivityRefPath = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3lzdGVtLWFjdGl2aXR5LWVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3lzdGVtLWFjdGl2aXR5L3N5c3RlbS1hY3Rpdml0eS1lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksb0JBR1g7QUFIRCxXQUFZLG9CQUFvQjtJQUM5QixxQ0FBYSxDQUFBO0lBQ2IseUNBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUhXLG9CQUFvQixHQUFwQiw0QkFBb0IsS0FBcEIsNEJBQW9CLFFBRy9CO0FBRUQsSUFBWSxxQkFJWDtBQUpELFdBQVkscUJBQXFCO0lBQy9CLHNDQUFhLENBQUE7SUFDYiwwREFBaUMsQ0FBQTtJQUNqQyxvREFBMkIsQ0FBQTtBQUM3QixDQUFDLEVBSlcscUJBQXFCLEdBQXJCLDZCQUFxQixLQUFyQiw2QkFBcUIsUUFJaEMifQ==